"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.versionContract = void 0;
const json_rpc_1 = require("@hediet/json-rpc");
const s = __importStar(require("@hediet/semantic-json"));
const types_1 = require("./types");
exports.versionContract = (0, json_rpc_1.contract)({
    name: "version",
    client: {},
    server: {
        /* def */ getVersions: (0, json_rpc_1.requestType)({
            params: s.sObject({
                orgId: s.sString(),
                projectId: s.sString(),
            }),
            result: s.sOpenObject({
                versions: s.sArrayOf(types_1.sVersionInfo),
            }),
        }),
        /* def */ exportVersion: (0, json_rpc_1.requestType)({
            params: s.sObject({
                version: types_1.sVersionRef,
            }),
            result: s.sOpenObject({
                export: types_1.sVersionExport,
            }),
        }),
        /* def */ importVersion: (0, json_rpc_1.requestType)({
            params: s.sObject({
                version: types_1.sVersionRef,
                import: types_1.sVersionExport,
            }),
        }),
        /* def */ getTranslatablesWithTranslations: (0, json_rpc_1.requestType)({
            params: s.sObject({
                version: types_1.sVersionRef,
            }),
            result: types_1.sTranslatablesWithTranslations,
        }),
        /* def */ postTranslation: (0, json_rpc_1.requestType)({
            params: s.sObject({
                version: types_1.sVersionRef,
                translatableId: s.sNumber(),
                languageCode: s.sString(),
                translatedFormat: s.sUnion([s.sString(), s.sNull()]),
            }),
        }),
        /* def */ syncTranslatables: (0, json_rpc_1.requestType)({
            params: s.sObject({
                version: types_1.sVersionRef,
                update: types_1.sTranslatablesUpdate,
            }),
            result: types_1.sTranslatablesSyncResult,
        }),
        /* def */ getTranslationsForLanguageCode: (0, json_rpc_1.requestType)({
            params: s.sObject({
                version: types_1.sVersionRef,
                languageCode: s.sString(),
                requestedPackageIds: s.prop(s.sArrayOf(s.sString()), {
                    optional: true,
                }),
            }),
            result: types_1.sTranslationsForLanguageCode,
        }),
        /* def */ getVersionInfo: (0, json_rpc_1.requestType)({
            params: s.sObject({
                version: types_1.sVersionRef,
            }),
            result: s.sOpenObject({
                defaultLanguageCode: s.sUnion([s.sString(), s.sNull()]),
                locked: s.sBoolean(),
                languages: s.sArrayOf(s.sOpenObject({
                    languageCode: s.sString(),
                    name: s.sString(),
                    published: s.sBoolean(),
                    translatedWords: s.sNumber(),
                    /** Between 0 and 100 */
                    translatedPercent: s.sNumber(),
                })),
            }),
        }),
        /* def */ deleteLanguage: (0, json_rpc_1.requestType)({
            params: s.sObject({
                version: types_1.sVersionRef,
                languageCode: s.sString(),
            }),
        }),
        /* def */ postLanguage: (0, json_rpc_1.requestType)({
            params: s.sObject({
                version: types_1.sVersionRef,
                languageCode: s.sString(),
                languageName: s.sString(),
            }),
        }),
        /* def */ updateVersion: (0, json_rpc_1.requestType)({
            params: s.sObject({
                version: types_1.sVersionRef,
                defaultLanguageCode: s.prop(s.sString(), {
                    optional: true,
                }),
                locked: s.prop(s.sBoolean(), {
                    optional: true,
                }),
            }),
        }),
        /* def */ updateLanguage: (0, json_rpc_1.requestType)({
            params: s.sObject({
                version: types_1.sVersionRef,
                languageCode: s.sString(),
                details: s.sObject({
                    published: s.prop(s.sBoolean(), {
                        optional: true,
                    }),
                    name: s.prop(s.sString(), {
                        optional: true,
                    }),
                }),
            }),
        }),
    },
});
//# sourceMappingURL=versionContract.js.map